import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

export default function ConversationThreads({conversation_threads} :any) {
  const columns = [
    {field: 'id', headerName: 'Ticker', width: 80, sortable: false, renderHeader:(params) => ( <strong>Ticker</strong>), renderCell: (params) => (params.getValue(params.id, 'ticker') )},
    {field: 'agent', headerName: 'Agent', width: 80, sortable: false, renderHeader:(params) => ( <strong>Agent</strong>)},
    {field: 'header',headerName: 'Subject', width: 300, sortable: true,renderHeader:(params) => ( <strong>Subject</strong>), renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={params.getValue(params.id, 'url') }><strong>{params.value}</strong></a>)},
    {field: 'date', headerName: 'Time', width: 180, renderHeader:(params) => ( <strong></strong>)}
  ];

  const rows = conversation_threads;

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <p><strong>AI Assistant Conversation Threads</strong></p>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            autoHeight={true}
            autoPageSize={true}
            density={"compact"}
            disableColumnMenu
          />
      </p>
    </div>
  );
}
